// i18n.js
import pt from "./pt.json";
import en from "./en.json";
import es from "./es.json";
import { reactive } from "vue";

const messages = {
  pt,
  en,
  es,
};

// Estado global reativo para o idioma selecionado
let state = reactive({
  currentLang: "pt",
});

export default {
  // Função para obter a tradução
  get(key, lang = state.currentLang) {
    return messages[lang][key] || key;
  },
  
  // Função para alterar o idioma
  setLanguage(lang) {
    state.currentLang = lang;
  },

  // Função para obter o idioma atual
  getCurrentLanguage() {
    return state.currentLang;
  },

  // Objeto reativo de estado
  state,
};
